import CycleMeasurement from '../enums/cycle-measurement';
import { Contract } from '../store/models/contracts';
import { CurrentLocation } from '../store/models/locations';

/**
 * Gets the measurement preference (Celsius/Fahrenheit) based on the hierarchy:
 * 1. Contract preference (if not null)
 * 2. Location preference (fallback)
 *
 * @param contract - The contract object (can be null/undefined)
 * @param currentLocation - The current location object (can be null/undefined)
 * @returns CycleMeasurement.Celsius or CycleMeasurement.Fahrenheit
 */
const getMeasurementPreference = (
  contract: Contract | null | undefined,
  currentLocation: CurrentLocation | null | undefined,
): CycleMeasurement => {
  // First check contract preference if it exists and isCelsius is not null
  if (contract && contract.isCelsius != null) {
    return contract.isCelsius ? CycleMeasurement.Celsius : CycleMeasurement.Fahrenheit;
  }

  // Fall back to location preference
  if (currentLocation) {
    return currentLocation.isCelsius ? CycleMeasurement.Celsius : CycleMeasurement.Fahrenheit;
  }

  // Default to Fahrenheit if nothing is set
  return CycleMeasurement.Fahrenheit;
};

export default getMeasurementPreference;
